module.exports = __webpack_public_path__ + "img/myyq.1560e8ef.jpg";